import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICorrelationPath } from '@app/api/interfaces/correlation-path.interface';

@Injectable({
  providedIn: 'root',
})
export class CorrelationsPathApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getOne(projectId: string, correlationId: string): Observable<IApiResponse<ICorrelationPath, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/correlations/${correlationId}/path`;

    return this.httpClient.get<IApiResponse<ICorrelationPath, object>>(url, {
      withCredentials: true,
    });
  }
}
